const SINGLE_QUOTE_REPLACEMENTS = /[\u2018\u2019\u201A\u201B\u2032\u02BC\uFF07\u02BB]/g;
const DOUBLE_QUOTE_REPLACEMENTS = /[\u201C\u201D\u201E\u2033\uFF02]/g;

export const sanitizeQuotes = (text: string): string =>
  text.replace(SINGLE_QUOTE_REPLACEMENTS, "'").replace(DOUBLE_QUOTE_REPLACEMENTS, '"');
